/**
 * @file CategoryKindField.tsx
 * @description «Вид товара по умолчанию» категории (phase19.22, W22, макет §4).
 *
 * Вид категории наследуют её товары и подкатегории. Первый вариант — «Как у
 * родителя (Пищевой)» (пусто → `productKindId: null`), дальше активные виды.
 * У системных категорий поля нет — вид там не бывает (422
 * `category_product_kind_system`); это решает вызывающий диалог.
 */

import { Label } from "../../ui/label";
import { SelectField } from "../../ui/SelectField";
import type { ProductKind } from "../../../lib/api-product-kinds";
import { kindSelectOptions } from "../../../lib/product-kind-resolve";

interface Props {
  /** Свой вид категории; "" — как у родителя. */
  value: string;
  onChange: (kindId: string) => void;
  kinds: ProductKind[];
  /** Вид от предков — подпись первого варианта; null — у предков вида нет. */
  inheritedKindName: string | null;
  disabled?: boolean;
}

export function CategoryKindField({ value, onChange, kinds, inheritedKindName, disabled }: Props) {
  const options = [
    { value: "", label: `Как у родителя (${inheritedKindName ?? "не задан"})` },
    ...kindSelectOptions(kinds, value),
  ];
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor="c-product-kind">Вид товара по умолчанию</Label>
      <SelectField
        id="c-product-kind"
        ariaLabel="Вид товара по умолчанию"
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
      />
      <p className="text-xs text-on-surface-variant">
        Товары категории получат срок годности, этикетку и НДС этого вида, если у товара
        не выбран свой.
      </p>
    </div>
  );
}
